import {faFolder} from "@fortawesome/pro-solid-svg-icons/faFolder";
import {faRemove} from "@fortawesome/pro-solid-svg-icons/faRemove";
import {faTag} from "@fortawesome/pro-solid-svg-icons/faTag";
import {IpmRqKeys} from "@twigsby/client-data/lib/Wrappers/ReactQuery/CacheKeys";
import {ItemMenuEntry} from "@twigsby/frontend-framework";
import {useTranslation} from "@twigsby/frontend-framework";
import {useMailbox} from "../../../Providers/NewMailboxProvider";
import {TagMenu} from "../../Tags/Menus/TagMenu";
import MailboxFolders from "../MailboxFolders";
import MailActionMenu from "./MailActionMenu";

type SelectedMailMenuContentType = {
    showCustomFolderRemove?: boolean;
}

const SelectedMailMenuContent = (props: SelectedMailMenuContentType) => {
    const { t } = useTranslation();
    const {
        mailBoxInfo,
        parsedFilters,
        UpdateMailTags,
        ActionItem,
        RemoveItemsFromFolder
    } = useMailbox();

    return (
        <>
            {props.showCustomFolderRemove && mailBoxInfo?.customFolderId && mailBoxInfo?.customFolderId !== -1 && (
                <>
                    <ItemMenuEntry title={t('customFolders.actions.removeFromFolder')} onClick={() => RemoveItemsFromFolder(mailBoxInfo.customFolderId as number)} icon={faRemove} />
                    <ItemMenuEntry title={t('divider')} sectionDivider={true} />
                </>
            )}

            <ItemMenuEntry icon={faFolder} title={t("mailboxes.actions.moveToFolder")}>
                <MailboxFolders mailItemContext={true} />
            </ItemMenuEntry>

            <ItemMenuEntry title={'Divider'} sectionDivider={true} />

            <ItemMenuEntry icon={faTag} title={t("mailboxes.actions.tagItems")} disableKeyboardEvents={true}>
                <TagMenu
                    dataKey={[IpmRqKeys.MAIL_BOX_KEY, parsedFilters]}
                    updateCallback={(e:any, b: boolean) => UpdateMailTags(e, b)}
                />
            </ItemMenuEntry>

            <ItemMenuEntry title={'Divider'} sectionDivider={true} />

            <MailActionMenu
                isMenu={true}
                actionCallback={(value: number) => ActionItem(value)}
            />
        </>
    )
}

export { SelectedMailMenuContent }
